import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
// import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "./newHome.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPauseCircle, faPlayCircle } from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  // const isAuthenticated = useSelector((state) => state.theme.isAuthenticated);
  const navigate = useNavigate();
  // const [showModal, setShowModal] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // const acceptModal = () => {
  //   setShowModal(false);
  //   Cookies.set("disclaimer", "true", { expires: 7 });
  // };

  // const closeModal = () => {
  //   setShowModal(false);
  // };

  // useEffect(() => {
  //   const cookie = Cookies.get("disclaimer");
  //   if (cookie === "true") {
  //     setShowModal(false);
  //   }
  // }, []);

  // if (isAuthenticated) {
  //   navigate("/chatbot");
  // }
  return (
    <>
      <div className="home-page">
        {/* Main Content */}
        <main className="home-main-content mt-auto mb-5">
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-md-5 d-flex justify-content-center">
                <div className="content-left px-5 py-4">
                  <h1 className="straf-logo p-0">Big Barrister</h1>
                  <h2 className="tagline mt-3 mb-0">
                    Boost Your Legal & Compliance Productivity with AI-Powered Assistance
                  </h2>
                  <p className="description mt-4 mb-5">
                    Instantly research legal topics, draft documents,
                    <br />
                    and streamline your workflow with the Big Barrister Legal
                    Bot.
                  </p>
                  <Link to="/chatbot" className="chatbot-btn fs-mobile">
                    Start Your Legal Journey with Big Barrister
                  </Link>
                </div>
              </div>
              <div className="col-md-7 text-center">
                <div className="video-container">
                  <video autoPlay muted playsInline loop preload="auto">
                    <source src="/video1.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </main>
        <section className="stravideo-section pt-5 row justify-content-center">
          <div className="col-md-12 px-0">
            <div className="straVideo position-relative">
              <video muted className="video-player w-100" ref={videoRef}>
                <source src="/Big Barrister.mp4" type="video/mp4" />
              </video>
              <button
                className="play-button position-absolute top-50 start-50 translate-middle"
                onClick={handlePlayPause}
              >
                {isPlaying ? (
                  <FontAwesomeIcon
                    icon={faPauseCircle}
                    size="3x"
                    color="white"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faPlayCircle}
                    size="3x"
                    color="white"
                  />
                )}
              </button>
            </div>
          </div>
        </section>
        {/* Footer */}
        <footer className="footer mt-auto">
          <div className="container-fluid py-4">
            <div className="d-flex align-items-center px-4">
              <Link to="/" className="footer-logo">
                {/* <svg
                  height="24"
                  viewBox="0 0 120 24"
                  width="120"
                  xmlns="http://www.w3.org/2000/svg"
                  className="stratinfo-logo-svg"
                >
                  <text
                    x="0"
                    y="18"
                    fill="#5f6368"
                    font-family="Arial"
                    font-weight="bold"
                    font-size="18"
                    className="footer-text"
                  >
                    Big Barrister
                  </text>
                </svg> */}
                <p className="footer-text mb-0 fs-1 fw-bold">Big Barrister</p>
              </Link>
              <div className="footer-links ms-5 d-flex gap-5">
                {/* <Link to="/pricing">Pricing</Link> */}
                {/* <Link to="/about">About</Link> */}
                {/* <div className="">
                  <Link to="/privacy-policy" className="mx-1">
                    Privacy
                  </Link>
                  <span>and</span>
                  <Link to="#" className="mx-1">
                    Terms
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </footer>
      </div>

      {/* <div
        className={`disclaimer-popoup  ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="theme-pagecontainer">
          <div className="container-fluid disclaimer-container d-flex ">
            <div className="col-md-10 content-box">
              <h4 className="modal-title mb-4">
                Haftungsausschluss (Disclaimer)
              </h4>
              <p>
                <strong>1. Inhalt der Website</strong>
                <br />
                Die auf dieser Website bereitgestellten Informationen dienen
                ausschließlich allgemeinen Informationszwecken und stellen keine
                rechtlich verbindliche Auskunft oder Beratung dar. Wir bemühen
                uns, die Inhalte stets aktuell und korrekt zu halten, übernehmen
                jedoch keine Gewähr für die Vollständigkeit, Richtigkeit oder
                Aktualität der bereitgestellten Informationen.
              </p>
              <p>
                <strong>2. Keine Rechtsberatung</strong>
                <br />
                Die auf unserer Website bereitgestellten Inhalte ersetzen keine
                individuelle und verbindliche Rechtsberatung. Die Nutzung der
                bereitgestellten Informationen erfolgt auf eigene Gefahr. Wir
                empfehlen, bei konkreten rechtlichen Fragestellungen stets einen
                qualifizierten Rechtsanwalt oder eine entsprechende Fachkraft zu
                konsultieren.
              </p>
              <p>
                <strong>3. Haftungsausschluss</strong>
                <br />
                Wir übernehmen keine Haftung für unmittelbare oder mittelbare
                Schäden, die durch die Nutzung oder Nichtnutzung der
                bereitgestellten Informationen entstehen, es sei denn, es liegt
                ein nachweislich vorsätzliches oder grob fahrlässiges
                Verschulden unsererseits vor. Dies gilt auch für Inhalte
                Dritter, die auf unserer Website eingebunden oder verlinkt sind.
              </p>
              <p>
                <strong>4. Verweise und Links</strong>
                <br />
                Unsere Website kann externe Links zu anderen Websites enthalten,
                auf deren Inhalte wir keinen Einfluss haben. Für den Inhalt der
                verlinkten Seiten sind ausschließlich deren Betreiber
                verantwortlich. Zum Zeitpunkt der Verlinkung waren keine
                rechtswidrigen Inhalte erkennbar. Eine ständige Überprüfung der
                verlinkten Seiten ist ohne konkrete Anhaltspunkte einer
                Rechtsverletzung nicht zumutbar.
              </p>
              <p>
                <strong>5. Urheberrecht</strong>
                <br />
                Die auf dieser Website bereitgestellten Inhalte und Werke
                unterliegen dem deutschen Urheberrecht. Jegliche
                Vervielfältigung, Bearbeitung, Verbreitung oder sonstige
                Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
                vorherigen schriftlichen Zustimmung des jeweiligen Autors oder
                Erstellers.
              </p>
              <p>
                <strong>6. Änderungen</strong>
                <br />
                Wir behalten uns das Recht vor, Teile der Website oder das
                gesamte Angebot ohne gesonderte Ankündigung zu ändern, zu
                ergänzen oder die Veröffentlichung zeitweise oder endgültig
                einzustellen.
              </p>
              <p>
                <strong>
                  7. Rechtswirksamkeit dieses Haftungsausschlusses
                </strong>
                <br />
                Sollten einzelne Bestimmungen dieses Haftungsausschlusses
                unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen
                Bestimmungen unberührt. An die Stelle der unwirksamen Regelung
                tritt eine dem Sinn und Zweck entsprechende gesetzliche
                Regelung.
              </p>
            </div>

            <div className="col-md-2 accept-btn">
              <button
                className="btn prim me-3 btn-custom"
                onClick={acceptModal}
              >
                Akzeptieren
              </button>
              <button
                className="btn btn-secondary btn-custom"
                onClick={closeModal}
              >
                Nicht erlaubt
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Home;
